import { render, staticRenderFns } from "./jy-outboundBoxList.vue?vue&type=template&id=6dd3e450&scoped=true&"
import script from "./jy-outboundBoxList.vue?vue&type=script&lang=js&"
export * from "./jy-outboundBoxList.vue?vue&type=script&lang=js&"
import style0 from "./jy-outboundBoxList.vue?vue&type=style&index=0&id=6dd3e450&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3e450",
  null
  
)

export default component.exports